import React from 'react';
import { Loader2 } from 'lucide-react';
import { cx } from '../cx';

type Variant = 'primary' | 'gradient' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

export interface SPButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  loading?: boolean;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
}

/**
 * Journey action button. Styling lives in `.sp-btn*` (scss/studentJourneyTheme.scss);
 * this only maps props → classes and handles the loading/disabled states.
 */
export const SPButton = React.forwardRef<HTMLButtonElement, SPButtonProps>(
  (
    { variant = 'primary', size = 'md', block, loading, disabled, iconLeft, iconRight, className, children, ...rest },
    ref,
  ) => (
    <button
      ref={ref}
      className={cx(
        'sp-btn',
        `sp-btn--${variant}`,
        size === 'sm' && 'sp-btn--sm',
        size === 'lg' && 'sp-btn--lg',
        block && 'sp-btn--block',
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Loader2 size={size === 'sm' ? 13 : 15} className="sp-spin" /> : iconLeft}
      {children}
      {!loading && iconRight}
    </button>
  ),
);
SPButton.displayName = 'SPButton';
